import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';
import { themeColors } from '../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  container: {
    margin: theme.spacing(2),
  },
  tableContainer: {
    borderRadius: theme.spacing(1),
    border: stylesConstants.defaultBorder,
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.default,
    maxWidth: stylesConstants.inputFormWidth * 2,
    marginTop: theme.spacing(2),
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  par: {
    color: themeColors.textComplimentary,
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: stylesConstants.inputFormWidth * 2,
  },
}));
